import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './Tray.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var TrayBase = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens;
  return _jsx(views.Tray, _objectSpread(_objectSpread({
    ref: ref
  }, tokens), {}, {
    children: children
  }));
});
var Tray = withDesignTokens(TrayBase, function () {
  return {};
}, {
  twilioLight: function twilioLight(theme) {
    return {
      borderColor: theme.palette.twilio.gray[20],
      backgroundColor: theme.palette.twilio.gray[10]
    };
  },
  light: function light(theme) {
    return {
      borderColor: theme.palette.twilio.gray[20],
      backgroundColor: theme.palette.twilio.gray[10]
    };
  },
  dark: function dark(theme) {
    return {
      borderColor: theme.palette.twilio.gray[20],
      backgroundColor: theme.palette.twilio.gray[10]
    };
  }
});
export default Tray;